import script from "./NewsFeed.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsFeed.vue?vue&type=script&lang=ts&setup=true"

import "./NewsFeed.vue?vue&type=style&index=0&id=71d6c97b&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d6c97b"]])

export default __exports__